// extracted by mini-css-extract-plugin
module.exports = {"login-form":"ForgotPassForm_login-form__1wDOE","cta-wrapper":"ForgotPassForm_cta-wrapper__2q7mb","submit-button":"ForgotPassForm_submit-button__1rVU_"};